/** Sub-account tools from the GHL parity roadmap. Each has a route now and a screen later. */
export interface ModuleInfo {
  path: string;
  name: string;
  summary: string;
  /** Reached from that module's screens rather than its own sidebar entry, unless the plan turns that module off */
  navUnder?: string;
}

export const MODULES: readonly ModuleInfo[] = [
  { path: 'contacts', name: 'Contacts', summary: 'Every lead and client, with tags, notes and history.' },
  { path: 'inbox', name: 'Inbox', summary: 'Texts, email and calls in one conversation view.' },
  { path: 'calendar', name: 'Calendar', summary: 'Booking pages, availability and reminders.' },
  { path: 'pipelines', name: 'Pipelines', summary: 'Opportunities moving through your sales stages.' },
  { path: 'automations', name: 'Automations', summary: 'Triggers and actions that follow up for you.' },
  { path: 'campaigns', name: 'Campaigns', summary: 'Email and text broadcasts to segments.' },
  { path: 'payments', name: 'Payments', summary: 'Invoices, payment links and subscriptions.' },
  { path: 'sites', name: 'Sites', summary: 'Funnels, websites and forms.' },
  { path: 'proposals', name: 'Proposals', summary: 'Proposals and contracts, signed electronically.' },
  { path: 'reputation', name: 'Reputation', summary: 'Reviews from Google and Facebook, requests, widgets and alerts.' },
  { path: 'ai', name: 'AI assistant', summary: 'Predictions and suggested replies, from shadow mode to auto.' },
  { path: 'courses', name: 'Courses', summary: 'Courses, memberships and the member portal.' },
  { path: 'communities', name: 'Communities', summary: 'Groups, posts and events for your members.', navUnder: 'courses' },
  { path: 'social', name: 'Social planner', summary: 'Plan, approve and publish posts; answer comments and DMs.' },
  { path: 'phone', name: 'Phone', summary: 'Numbers, call flows, the call log and the dialer.' },
  { path: 'voice_ai', name: 'Voice AI', summary: 'An AI receptionist that answers calls, books and takes messages.' },
  { path: 'integrations', name: 'Integrations', summary: 'Apps, connectors and webhooks.' },
  { path: 'knowledge', name: 'Knowledge base', summary: 'What your AI knows, and its guards.' },
  { path: 'medspa', name: 'Med spa', summary: 'Treatments, packages and memberships, deposits, consent, photos and rebooking.' },
  { path: 'home_services', name: 'Home services', summary: 'Dispatch, jobs, good / better / best estimates, technicians, maintenance plans and service areas.' },
  { path: 'dental', name: 'Dental', summary: 'Recall, plans and booking.' },
  { path: 'ai_employees', name: 'AI employees', summary: 'AI assistants that answer, book and follow up, and hand conversations to each other and to you.' },
];

/** Plan modules with no sub-account screen of their own: plans can still switch them off (the agency's branded mobile app) */
export const PLAN_ADDONS: readonly ModuleInfo[] = [{ path: 'white_label_app', name: 'Branded mobile app', summary: "The agency's own iOS and Android app." }];

/** Every module a plan can switch on or off */
export const PLAN_SWITCHABLE: readonly ModuleInfo[] = [...MODULES, ...PLAN_ADDONS];
